import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const DualRoleDashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  // Menu items for admin/committee functions
  const adminMenuItems = [
    { title: 'Gestisci utenti', icon: 'bi-people', path: '/admin/user', description: 'Crea e gestisci utenti del sistema' },
    { title: 'Gestisci eventi', icon: 'bi-calendar-event', path: '/admin/events', description: 'Crea e gestisci eventi sportivi' },
  ];

  // Menu items for association functions
  const associationMenuItems = [
    { title: 'Eventi disponibili', icon: 'bi-calendar-check', path: '/association', description: 'Visualizza e iscriviti agli eventi' },
    { title: 'I tuoi soci', icon: 'bi-people-fill', path: '/association/members', description: 'Gestisci i membri della tua associazione' },
  ];

  return (
    <div className="container-fluid min-vh-100" style={{ background: 'linear-gradient(135deg, #006e39, #52b788)' }}>
      <div className="row p-2 p-md-4">
        <div className="col-12">
          <div className="glass-container p-3 p-md-4 rounded-4" style={{ backdropFilter: 'blur(10px)', backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
            
            {/* Header */}
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-2">
              <div>
                <h1 style={{ color: "#006e39" }} className="mb-2 fs-3 fs-md-1">Dashboard Comitato</h1>
                <p className="text-muted mb-0">
                  <i className="bi bi-person-badge me-2"></i>
                  {user.email} - <strong>{user.role}</strong>
                  {user.discipline && <span className="ms-2">| Disciplina: <strong>{user.discipline}</strong></span>}
                </p>
              </div>
            </div>

            {/* Info alert for dual role */}
            <div className="alert alert-info d-flex align-items-center mb-4" role="alert">
              <i className="bi bi-info-circle-fill me-3 fs-4"></i>
              <div>
                <strong>Dual Role Attivo!</strong> 
                <p className="mb-0">Hai accesso sia alle funzioni di <strong>gestione comitato</strong> che alle funzioni di <strong>iscrizione membri</strong> agli eventi.</p>
              </div>
            </div>

            {/* Admin/Committee Functions Section */}
            <div className="mb-5">
              <h3 style={{ color: "#006e39" }} className="mb-3">
                <i className="bi bi-gear-fill me-2"></i>
                Funzioni Amministrative
              </h3>
              <p style={{ color: "#2b6a4e", fontWeight: "500" }} className="mb-4">
                Gestisci utenti, crea eventi e configura il sistema.
              </p>

              <div className="row g-4">
                {adminMenuItems.map((item, index) => (
                  <div key={index} className="col-12 col-sm-6 col-lg-4">
                    <div
                      className="glass-card p-4 rounded-4 h-100"
                      style={{
                        background: '#ffffff',
                        border: '2px solid #006e39',
                        boxShadow: '0 2px 8px rgba(0, 110, 57, 0.1)',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease'
                      }}
                      onClick={() => navigate(item.path)}
                      onMouseOver={(e) => {
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 110, 57, 0.25)';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.borderColor = '#00552c';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 110, 57, 0.1)';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.borderColor = '#006e39';
                      }}
                    >
                      <div className="d-flex align-items-start">
                        <div className="rounded-circle p-3 me-3" style={{ backgroundColor: 'rgba(0, 110, 57, 0.1)' }}>
                          <i className={`bi ${item.icon} fs-2`} style={{ color: '#006e39' }}></i>
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="mb-2" style={{ color: '#006e39', fontWeight: '600' }}>{item.title}</h5>
                          <p className="text-muted small mb-0">{item.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Divider */}
            <hr className="my-5" style={{ borderColor: '#006e39', opacity: 0.2 }} />

            {/* Association Functions Section */}
            <div>
              <h3 style={{ color: "#006e39" }} className="mb-3">
                <i className="bi bi-building me-2"></i>
                Funzioni Associazione
              </h3>
              <p style={{ color: "#2b6a4e", fontWeight: "500" }} className="mb-4">
                Visualizza eventi disponibili e iscriviti con i tuoi soci.
              </p>

              <div className="row g-4">
                {associationMenuItems.map((item, index) => (
                  <div key={index} className="col-12 col-sm-6 col-lg-4">
                    <div
                      className="glass-card p-4 rounded-4 h-100"
                      style={{
                        background: '#ffffff',
                        border: '2px solid #52b788',
                        boxShadow: '0 2px 8px rgba(82, 183, 136, 0.1)',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease'
                      }}
                      onClick={() => navigate(item.path)}
                      onMouseOver={(e) => {
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(82, 183, 136, 0.25)';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.borderColor = '#40916c';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(82, 183, 136, 0.1)';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.borderColor = '#52b788';
                      }}
                    >
                      <div className="d-flex align-items-start">
                        <div className="rounded-circle p-3 me-3" style={{ backgroundColor: 'rgba(82, 183, 136, 0.1)' }}>
                          <i className={`bi ${item.icon} fs-2`} style={{ color: '#52b788' }}></i>
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="mb-2" style={{ color: '#40916c', fontWeight: '600' }}>{item.title}</h5>
                          <p className="text-muted small mb-0">{item.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default DualRoleDashboard;
